import { HttpError } from '../client/httpClient';
import { checkHostConnection } from './checkHostConnection';
export const isNetworkError = async (error) => {
    const hasHostConnect = await checkHostConnection();
    const isServerError = error instanceof Response && error.status > 499;
    const isCustomServerError = error instanceof HttpError && error?.statusCode > 499;
    return !hasHostConnect || isServerError || isCustomServerError;
};
